import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import isEqual from 'lodash/isEqual';
import React, { FC, memo, useCallback } from 'react';
import { connect } from 'react-redux';
import CustomDataGrid from 'src/components/DataGrid';
import { getReceiptsViewReceiptsData } from 'src/routes/Receipts/store/receiptsViewSlice';
import { SupplierItem } from 'src/routes/Receipts/store/services/types';
import { RootState } from 'src/store';

const columns: GridColDef<SupplierItem[][number]>[] = [
  {
    field: 'vendor',
    headerName: 'ספק',
    align: 'center',
    headerAlign: 'center',
    width: 150,
  },
  {
    field: 'date',
    headerName: 'תאריך שנמצא',
    align: 'center',
    headerAlign: 'center',
    width: 150,
    valueFormatter: (value, row) => dayjs(value as string).format('DD/MM/YYYY'),
  },
  {
    field: 'amount',
    headerName: 'סכום',
    align: 'center',
    headerAlign: 'center',
    type: 'number',
    width: 150,
  },
  {
    field: 'category',
    headerName: 'קטגוריה',
    align: 'center',
    headerAlign: 'center',
    description: 'This column has a value getter and is not sortable.',
    width: 150,
  },
];

type Props = ReturnType<typeof mapStateToProps>;

const ResultsTable: FC<Props> = ({ suppliers }) => {
  const handleActionClick = useCallback((id: string | number) => {
    console.log('Action clicked for row:', id);
    // Add your action handling logic here
  }, []);

  return (
    <CustomDataGrid
      rows={suppliers ?? []}
      columns={columns}
      withActionsMenu
      onActionClick={handleActionClick}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  suppliers: getReceiptsViewReceiptsData(state),
});

export default connect(mapStateToProps)(memo(ResultsTable, isEqual));
